import React, { useState, useEffect, useRef } from "react";
import { Form, Button, Input, List, Divider, message } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import axios from "axios";
import './index.global.css';
import { query2Obj } from "../../utils/tools.ts";

export default function (){
    // state
    const [countDown, setCountDown] = useState<number>(60)
    const [twiceFlag, setTwiceFlag] = useState(false)
    // const [twiceAccount, setTwiceAccount] = useState()
    const twiceAccount = useRef()
    const [codeType, setCodeType] = useState("mobile")
    const [downMenuVisible, setDownMenuVisible] = useState(false)
    const [sendCaptchaFlag, setSendCaptchaFlag] = useState(true)
    const [loginForm] = Form.useForm()

    // rules
    const rules = {
        userName: [
            { required: true, message: '请输入用户名' }
        ],
        password: [
            { required: true, message: '请输入密码' }
        ],
        captcha: [
            { required: true, message: '请输入验证码' },
            { pattern: /^\d{4}$/, message: '请输入4位数字验证码' }
        ]
    }

    // methods
    const sendCaptcha = async (e)=>{
        e.stopPropagation()
        loginForm.validateFields(["userName", "password"]).then(value=>{
            getCaptcha(value)
        }).catch(err=>{})
    }
    const handleStaticLogin = (values)=>{
        if(!twiceFlag){
            // 未开启验证码登录
            staticLogin(values)
        }else{
            // 开启验证码登录
            dynamicLogin(values)
        }
    }

    // api
    async function staticLogin(values:any) {
        const res = await axios.get(`/c/xfaccountsso/api/user/check?name=${values.userName}&password=${values.password}`)
        if(res.data.result == "ok"){
            const search = query2Obj(window.location.search)
            window.location.href = `${search.redirect_url}&state=${search.state}&code=${res.data.code}`
        }else{
            message.error("认证失败")
        }
    }
    async function dynamicLogin(values){
        const res = await axios.get(`/c/XFEncrypt/api/v1/checkYZM?mobile=${twiceAccount.current}&code=${values.captcha}`)
        if(res.data.data){
            staticLogin(values)
        }else{
            message.error("验证码错误")
        }
    }
    async function getCaptcha(data) {
        // 
        const account =await axios.get(`/c/XFEncrypt/api/v1/getMobileByEmail?email=${data.userName}`)
        if(!account.data.mobile && !account.data.email){
            message.error('账号未填写手机号码和邮箱,请联系管理员')
            return
        }
        if(!account.data.mobile){
            message.error('账号未填写手机号码')
            twiceAccount.current = account.data.email
        }
        // setTwiceAccount(account.data.phone)
        twiceAccount.current = account.data.mobile
        const res = await axios.get(`/c/XFEncrypt/api/v1/sendYZM?email=${account.data.email}&mobile=${account.data.mobile}&type=${codeType}`)
        if(res.data.code == 0){
            message.success(`验证码已发送`)
            setSendCaptchaFlag(false)
            let count = countDown
            let timer = setInterval(()=>{
                const next = count - 1
                count = next
                setCountDown(next)
                if(next <= 0){
                    setSendCaptchaFlag(true)
                    clearInterval(timer)
                    timer = null
                }
            },1000)
        }else{
            message.error(res.data.msg?res.data.msg:'发送验证码失败，请重试')
            setSendCaptchaFlag(true)
        }
    }
    async function getTwiceCodeFlag(){
        // 查询管理后台是否开启验证码登录
        const resp=await axios({
            method:'get',
            url:`/c/XFEncrypt/api/v1/getTbConfigByName?name=yzm`,
        })
        const iscCodeLogin =resp.data.data[0].flag==1?true:false
        // 判断是否为内网IP
        const res:any=await axios({
            method:'get',
            url:`/c/XFEncrypt/api/v1/checkInnerIpFlag`
        })
        const isInnerIP = res.data.flag
        setTwiceFlag(iscCodeLogin && !isInnerIP)
    }

    // hooks
    useEffect(()=>{
        // document.title = ""
        getTwiceCodeFlag()
    },[])
    // component
    const CaptchaDownMenu = <Button className="captcha-btn" onClick={sendCaptcha} disabled={!sendCaptchaFlag}>
        {sendCaptchaFlag
         ? (codeType == "mobile" ? "手机获取验证码" : "邮箱获取验证码") 
         : `${countDown} S` 
        }
        {downMenuVisible
         ? <UpOutlined style={{marginLeft: "4px", display:`${sendCaptchaFlag?"block":"none"}`}} onClick={(e)=>{e.stopPropagation(); setDownMenuVisible(!downMenuVisible)}} />
         : <DownOutlined style={{marginLeft: "4px", display:`${sendCaptchaFlag?"block":"none"}`}} onClick={(e)=>{e.stopPropagation(); setDownMenuVisible(!downMenuVisible)}} />
        }
        {downMenuVisible
         ? <List className="captcha-downmenu">
            <List.Item onClick={()=>{setCodeType("mobile")}}>手机获取验证码</List.Item>
            <List.Item onClick={()=>{setCodeType("email")}}>邮箱获取验证码</List.Item>
           </List>
         : <></>
        }
    </Button>

    return (<>
        <div className="header">
            <img className="logo" src="data:image/png;base64,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" alt="" />
        </div>
        <Divider style={{margin: 0}} />
        <div className="loginWrap">
            <div className="title">
                <div className="main-title">登录</div>
                <div className="sub-title">请使用企业统一帐号密码登录</div>
            </div>
            <div className="content">
                <Form form={loginForm} onFinish={handleStaticLogin}>
                    <Form.Item name="userName" rules={rules.userName}>
                        <Input size="large"
                            allowClear 
                            placeholder="帐号"  />
                    </Form.Item>
                    <Form.Item name="password" rules={rules.password}>
                        <Input.Password
                            size="large" 
                            allowClear
                            placeholder="密码" />
                    </Form.Item>
                    {twiceFlag
                     ? <Form.Item name="captcha" rules={rules.captcha}>
                        <Input size="large" placeholder="验证码" addonAfter={CaptchaDownMenu}/>
                       </Form.Item>
                     : <></>
                    }
                    <Form.Item>
                        <div className="footer">
                            <Button type="primary" block htmlType="submit">立即登录</Button>
                        </div>
                    </Form.Item>
                </Form>
            </div>
        </div>
    </>)
}